"use client";

import { Moon, Sun } from "lucide-react";

import { useAuth } from "../AuthProvider";

function ThemeToggle() {
  const { user } = useAuth();

  const toggleDarkMode = () => {
    const isDark = document.documentElement.classList.contains("dark");
    localStorage.setItem("theme", isDark ? "light" : "dark");

    if (isDark) {
      document.documentElement.classList.remove("dark");
    } else {
      document.documentElement.classList.add("dark");
    }
  };

  // Only show theme toggle when user is not logged in
  if (user) {
    return null;
  }

  return (
    <button
      aria-label="Toggle theme"
      className={`
    p-3 -ml-2 rounded-lg transition-colors cursor-pointer
    text-body-muted hover:text-body
  `}
      onClick={toggleDarkMode}
    >
      <Sun className="block dark:hidden" size={20} />
      <Moon className="hidden dark:block" size={20} />
    </button>
  );
}

export default ThemeToggle;
